module.exports = __webpack_public_path__ + "img/lx_dplb.96bf59a2.svg";